import type { PlaybookId } from "@repo/app-types/entities/playbook";
import { type FC, type ReactNode, useMemo } from "react";
import { FilterDefaultOverridesProvider } from "./filterDefaultOverridesProvider.js";
import type { PlaybookHasResultCondition } from "./playbookCondition.js";

export function buildHasResultPlaybookCondition(
  playbookId: PlaybookId,
): PlaybookHasResultCondition {
  return { playbookId, kind: "has_result" };
}

export interface PlaybookHasResultFilterDefaultProps {
  playbookId: PlaybookId;
  children?: ReactNode;
}

/**
 * Defaults the "Playbook results" filter to the playbook's "has result"
 * condition so voicemail-like calls (every criterion N/A) are filtered out by
 * default. The condition is controlled by "Include calls without grades" in
 * the Playbook results menu instead of appearing as a removable chip. Wraps
 * the playbook page layouts' outlets so every page under a playbook gets the
 * default.
 */
export const PlaybookHasResultFilterDefault: FC<
  PlaybookHasResultFilterDefaultProps
> = ({ playbookId, children }) => {
  const overrides = useMemo(
    () => ({
      playbookConditions: [buildHasResultPlaybookCondition(playbookId)],
    }),
    [playbookId],
  );

  return (
    <FilterDefaultOverridesProvider overrides={overrides}>
      {children}
    </FilterDefaultOverridesProvider>
  );
};
